import type { FC, PropsWithChildren, ReactElement } from 'react'

import { StyledText } from '@skytech/ui'

import RouterLink from '@/components/RouterLink'

import './NotificationCard.styles.scss'

export const NotificationCard: FC<
  PropsWithChildren<{
    to: string
    count: number
    cardTitle?: string | ReactElement
  }>
> = ({ to, count, children, cardTitle }) => {
  if (count === 0) return null
  return (
    <div className="fade-in-cards">
      <RouterLink
        to={to}
        colorMode="dark-gray"
        className="shadow-basic relative flex h-[168px] min-w-[250px] max-w-md flex-col items-center overflow-hidden rounded-xl bg-white duration-200 ease-out hover:scale-105 md:mb-5"
        hasUnderline={false}
      >
        {children}

        <h1 className="mb-[0.3px] mt-4 flex max-w-64 flex-auto flex-shrink text-center text-base font-medium uppercase text-black">
          {cardTitle}
        </h1>

        <StyledText>
          <h2 className="mb-2 mt-0 text-center text-[78px] font-medium">{count} </h2>
        </StyledText>
      </RouterLink>
    </div>
  )
}
